import {Modal} from 'bootstrap';
export class Item{
    constructor(trigger){
        this.trigger = trigger;
        this.setModal();
        // this.setForm(form);
        this.submitCallback = null;
        this.pageForm = null;
        this.fetchedData = null;
    }
    async fetchData(){
        window.loading();
        const response = await fetch(this.trigger.dataset.get, {
            method: 'post',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                id: this.trigger.dataset.id
            })
        });
        const data = await response.json();
        return data;
    }
    setModal(){
        this.modalElement = document.querySelector('#page-modal');
        this.modalElement.querySelector('.modal-title').textContent = this.trigger.dataset.title;
        this.modal = new Modal(this.modalElement);
    }
    setForm(form){
        this.pageForm = document.createElement('form');
        this.pageForm.className = 'page-form';
        this.pageForm.action = this.trigger.dataset.submit;
        this.pageForm.innerHTML = form;
        this.pageFormContainer = document.querySelector('#page-form-container');
        this.pageFormContainer.innerHTML = '';
        this.pageFormContainer.appendChild(this.pageForm);
        this.pageForm.addEventListener('submit', this.submitForm.bind(this));
        this.modal.show();
    }
    submitForm(e){
        e.preventDefault();
        window.loading();
        let formData = new FormData(this.pageForm);
        fetch(this.pageForm.action, {
            method : 'post',
            headers : {
                'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body : formData
        })
        .then(response => response.json())
        .then(data => {
            this.submitCallback(data);
        })
    }
}